import { QueryFunction } from '@tanstack/react-query';
import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { INCOME_SOURCES, type IncomeSource } from 'src/pages/loan/income/data';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import { toIncomeSource, type LoanIncomeDto } from './mapLoanIncome';

export interface GetLoanIncomesParams {
  loanId: string;
}

const getLoanIncomes: QueryFunction<
  IncomeSource[],
  ['/loans/incomes', GetLoanIncomesParams]
> = async ({ queryKey }) => {
  const [, params] = queryKey;
  if (isMockServices()) return await mock(INCOME_SOURCES);

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<{
    success: boolean;
    data: LoanIncomeDto[];
  }>(`/loans/${params.loanId}/incomes`, { method: 'GET' });

  if (response.data) return (response.data.data ?? []).map(toIncomeSource);
  throw new Error('Failed to fetch incomes for this loan');
};

export default getLoanIncomes;
